import { render, staticRenderFns } from "./notices.vue?vue&type=template&id=b80f07c4&scoped=true&"
import script from "./notices.vue?vue&type=script&lang=js&"
export * from "./notices.vue?vue&type=script&lang=js&"
import style0 from "./notices.vue?vue&type=style&index=0&id=b80f07c4&prod&lang=scss&scoped=true&"
import style1 from "./notices.vue?vue&type=style&index=1&id=b80f07c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80f07c4",
  null
  
)

export default component.exports